import {RouteConfig} from 'vue-router/types/router';

/** Statistics pages (/stats and its sub pages) */
export const STATS_ROUTES: RouteConfig[] = [
    {
        path: '/stats',
        name: 'Statistiken und Analysen',
        component: () => import(/* webpackChunkName: "stats" */ '@/views/Stats.vue'),
    },
    {
        path: '/stats/teacher-churn',
        name: 'Kündigungsquote je Lehrkraft',
        component: () => import(/* webpackChunkName: "teacher-churn" */ '@/views/stats/TeacherChurnStats.vue'),
    },
    {
        path: '/stats/teacher-excess',
        name: 'Mehr Abgänge als erwartet',
        component: () => import(/* webpackChunkName: "teacher-excess" */ '@/views/stats/TeacherExcessStats.vue'),
    },
    {
        path: '/stats/employee-acquisition-stats',
        name: 'Akquiseleistung der Mitarbeitenden',
        component: () => import(/* webpackChunkName: "employee-acquisition-stats" */ '@/views/stats/EmployeeAcquisitionStats.vue'),
    },
    {
        path: '/stats/employee-performance',
        name: 'Performance der Mitarbeitenden',
        component: () => import(/* webpackChunkName: "employee-performance" */ '@/views/stats/EmployeePerformanceStats.vue'),
    },
    {
        path: '/stats/signups-per-institution',
        name: 'Anmeldungen je Standort',
        component: () => import(/* webpackChunkName: "signups-per-institution" */ '@/views/stats/SignupsPerInstitution.vue'),
    },
    {
        path: '/stats/student-retention',
        name: 'Verbleibsdauer',
        component: () => import(/* webpackChunkName: "student-retention" */ '@/views/stats/StudentRetentionStats.vue'),
    },
    {
        path: '/stats/institution-development',
        name: 'Standortentwicklung',
        component: () => import(/* webpackChunkName: "institution-development" */ '@/views/stats/InstitutionDevelopmentStats.vue'),
    },
    {
        path: '/stats/substitution-stats',
        name: 'Vertretungen und Ausfälle',
        component: () => import(/* webpackChunkName: "substitution-stats" */ '@/views/stats/SubstitutionStats.vue'),
    },
    {
        path: '/stats/missing-course-logs',
        name: 'Offene Protokolle pro Lehrkraft',
        component: () => import(/* webpackChunkName: "missing-course-logs" */ '@/views/stats/MissingCourseLogsStats.vue'),
    },
    {
        path: '/stats/profitability',
        name: 'Rentabilität',
        component: () => import(/* webpackChunkName: "profitability" */ '@/views/stats/ProfitabilityStats.vue'),
    },
    {
        path: '/stats/profitability/course/:customId',
        name: 'Rentabilität eines Kurses',
        component: () => import(/* webpackChunkName: "profitability" */ '@/views/stats/ProfitabilityCourseStats.vue'),
    },
];
